/* eslint-disable import/prefer-default-export */

export class VoucherifyServiceUtil {

  /**
   * Performs a minimal Voucherify API request to verify that
   * the API credentials are valid.
   *
   * @param applicationId
   * @param clientSecret
   * @param region
   * @return {Promise<boolean>}
   */
  static async testVoucherifyConnection({
    applicationId,
    clientSecret,
    region,
  }) {
    if (!applicationId || !clientSecret || !region) {
      return false;
    }

    let regionUrlPart = '';
    if (region === 'europe') {
      regionUrlPart = 'eu1.';
    } else if (region === 'us') {
      regionUrlPart = 'us1.';
    } else if (region === 'asia') {
      regionUrlPart = 'ap1.';
    }

    const endpointUrl = `https://${regionUrlPart}api.voucherify.io/v1/customers?limit=1`;

    const response = await fetch(endpointUrl, {
      method: 'GET',
      headers: {
        'X-App-Id': applicationId,
        'X-App-Token': clientSecret,
      },
    });

    if (response.ok) {
      return true;
    } else {
      return false;
    }
  }

}
